import {Injectable} from '@angular/core';
import {AttachmentRepository} from "../repositories/attachment.repository";
import {FilterService} from "./filterer/filter.service";
import {Dtos} from "../utils/dtos";
import {DataManipulationService} from "./common/data-manipulation.service";
import {ValidatorService} from "./common/validator.service";
import {MbColDefinition, MbColInput} from "../components/mb-datatable/models/mb-datatable.model";
import {BaseService} from "./common/base.service";
import {AttachmentUrlService} from "./common/attachment-url.service";
import {OrderByModel} from "./filterer/orderBy.model";

@Injectable({
    providedIn: 'root'
})
export class AttachmentService extends BaseService<AttachmentRepository> {

    constructor(repo: AttachmentRepository, filterService: FilterService, dataManipulationService: DataManipulationService, validatorService: ValidatorService,
                public attachmentUrlService: AttachmentUrlService) {
        super(repo, filterService, dataManipulationService, validatorService);
        this.typeName = "Attachment";
    }

    getAllNotFrontendElement() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .matchStart('mimeType', 'image/')
            .and()
            .equal('frontendElement', false)
            .create();
        return this.repo.getAllByFilter(filter);
    }

    getAllForProduct() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .matchStart('mimeType', 'image/')
            .and()
            .equal('productReady', true)
            .orderBy(OrderByModel.desc('createdAt'))
            .create();
        return this.repo.getAllByFilter(filter);
    }
    getAllIcon() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .match('mimeType', 'svg')
            .create();
        return this.repo.getAllByFilter(filter);
    }
    getAllImage() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .matchStart('mimeType', 'image/')
            .create();
        return this.repo.getAllByFilter(filter);
    }

    getAllForFrontend() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .matchStart('mimeType', 'image/')
            .and()
            .equal('frontendElement', true)
            .create();
        return this.repo.getAllByFilter(filter);
    }

    getAllNotFrontendSvgElement() {
        const filter = this.filterService.filter(Dtos.ATTACHMENT.AttachmentDTO)
            .equal('deleted', false)
            .and()
            .matchStart('mimeType', 'image/svg')
            .and()
            .equal('frontendElement', false)
            .create();
        return this.repo.getAllByFilter(filter);
    }

    getAllDeletable() {
        return this.repo.getAllDeletable();
    }

    saveFileAndAttachment(file: File, attachment: AttachmentModel) {
        return this.repo.saveFileAndAttachment(file, attachment);
    }
    updateFileForAttachment(file: File, attachmentId:number) {
        return this.repo.updateFileForAttachment(file, attachmentId);
    }
    clearCacheForAttachment(id:number) {
        return this.repo.clearCacheForAttachment( id);
    }

    deleteById(id) {
        return this.repo.deleteById(id);
    }


    addExtraDataForOne(model: any): any {
        model = this.dataManipulationService.addLocalizedAttributeToElement(model, 'title', 'localization');
        model = this.dataManipulationService.addLocalizedAttributeToElement(model, 'slug', 'localization');
        model.name = model.title;
        model.src = this.attachmentUrlService.getScaleHeightImageUrl(model.localization, 200);
        model.downloadLink = this.attachmentUrlService.getDownloadUrl(model.localization);
        return model;
    }

    protected defineModelSpecificColumns(extraInfo?: any): any[] {
        return [
            MbColDefinition.new('name', 'attachment.name'),
            MbColDefinition.new('slug', 'attachment.slug'),
            MbColDefinition.new('fileName', 'attachment.fileName'),
            MbColDefinition.new('productReady', 'attachment.productReady', MbColInput.new(MbColInput.SELECT, [
                {label: 'general.true', value: 'true'},
                {label: 'general.false', value: 'false'}
            ])),
        ];
    }



}

export class AttachmentModel {
    localization
}
